import { styled } from '@mui/material/styles';
import List from '@mui/material/List';

const SidebarList = styled(List)(() => ({
    minHeight: 48,
}));

export default SidebarList;
